import { Component, Input } from '@angular/core';
import { ErrorMessagingServiceService } from '@services';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-mat-hint',
  templateUrl: './custom-mat-hint.component.html',
  styleUrls: ['./custom-mat-hint.component.scss'],
  standalone: false
})
export class CustomMatHintComponent {
  @Input() public isCheckTouch: boolean;
  @Input() public formGroup: FormGroup;
  @Input() public controlName: string;
  constructor(public errorMessagingService: ErrorMessagingServiceService) { }



}
